/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, FlexRow, FlexCol, Button, NumberField } from 'sarsaparilla';
import SmartSelector from './SmartSelector';

const propTypes = {
    options: PropTypes.arrayOf(PropTypes.any),
    removeWatercraft: PropTypes.func,
    handleWatercraftChange: PropTypes.func,
    watercraft: PropTypes.any,
    index: PropTypes.number,
    maxHit: PropTypes.bool,
};
export default class WatercraftItem extends React.PureComponent {
    static propTypes = propTypes;

    onClickRemove = () => this.props.removeWatercraft(+this.props.index || 0);

    changeWatercraftType = (event) =>
        this.props.handleWatercraftChange(this.props.index, event.target.id, event);

    changeWatercraftQuantity = ({ target: { id, value } }) =>
        this.props.handleWatercraftChange(this.props.index, id, value);

    renderRemoveButton() {
        const { index } = this.props;

        if (index > 0) {
            return (
                <FlexCol alignSelf="end" justifyContent="start" md={1}>
                    <div className="per-form-group-item-remove">
                        <Button
                            appearance="subtle-danger"
                            iconBeforeElement={<Icon iconName="delete" />}
                            screenReaderTextAfter={`watercraft type # ${index + 1}`}
                            onClick={this.onClickRemove}
                        >
                            Delete
                        </Button>
                    </div>
                </FlexCol>
            );
        }
        return <div />;
    }

    render() {
        const selectorProps = {
            name: 'watercraft-type',
            id: `watercraft-type-${this.props.index}`,
            value: this.props.watercraft.type.toString(),
            placeholderOption: { value: '', label: 'Select from list' },
            handleChange: this.changeWatercraftType,
            options: this.props.options,
            label: 'Type',
            isLabelVisible: true,
            isRequired: true,
        };
        const id = `watercraft-amount-${this.props.index}`;

        return (
            <div
                data-testid="watercraft-item"
                aria-label={`Watercraft type # ${this.props.index + 1}`}
                className="per-form-group-item"
            >
                <FlexRow alignItems="end">
                    <FlexCol md={4}>
                        <div className="rec-form-item-wrap">
                            <SmartSelector
                                name={selectorProps.name}
                                id={selectorProps.id}
                                value={selectorProps.value}
                                placeholderOption={selectorProps.placeholderOption}
                                handleChange={selectorProps.handleChange}
                                options={selectorProps.options}
                                label={selectorProps.label}
                                isLabelVisible={selectorProps.isLabelVisible}
                                isRequired={selectorProps.isRequired}
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={2}>
                        <div className="rec-form-item-wrap">
                            <NumberField
                                id={id}
                                isRequired
                                isIncreaseDisabled={this.props.maxHit}
                                min={0}
                                step={1}
                                units="watercraft"
                                value={this.props.watercraft.amount || 0}
                                onChange={(value) =>
                                    this.changeWatercraftQuantity({
                                        target: { id, value },
                                    })
                                }
                                visualLabel="Quantity"
                                visualLabelPosition="top"
                            />
                        </div>
                    </FlexCol>
                    {this.renderRemoveButton()}
                </FlexRow>
            </div>
        );
    }
}

// cspell:ignore testid
